import { render, staticRenderFns } from "./CPFInput.vue?vue&type=template&id=1f6e2d8c&scoped=true&"
import script from "./CPFInput.vue?vue&type=script&lang=js&"
export * from "./CPFInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e2d8c",
  null
  
)

export default component.exports